import API from 'shared/constants/api';
import uniq from 'lodash/uniq';
import TITLE from 'shared/constants/seoTitles';
import LINKS from 'desktop/constants/navigation';
import {
  setFormVocabulary,
  selectedActions,
  sparesFormFillThunks,
  sparesSetThunks,
  resultsThunks,
} from 'shared/actions/searchForm';
import { compareByTitle } from 'shared/helpers/arrays';
import types from 'shared/constants/json/transportTypes.json';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import { DEALER_TABS } from 'shared/constants/navigation';
import snakeCaseKeys from 'snakecase-keys';
import queryString from 'query-string';

const PER_PAGE = 20;
const AUTO_ID = 1;
const FIRMS_TYPE_IDS = [1, 124, 196, 200, 267, 23, 168];

const fetchNews = (fetch, agencyID, locale) =>
  fetch(API.JOURNAL.LIST({ agency: agencyID, language: locale })).then(r => r.json());

async function action({ fetch, baseUrl, path, params, query, translate, store }) {
  const url = `${baseUrl}${path}`.replace('//', '/');
  const { id } = params;
  const state = store.getState();
  const { locale } = state.globals;

  if (!id) {
    return null;
  }

  const firm = (await fetch(API.FIRMS.ITEM(id)).then(r => r.json())) || {};
  if (!firm.id) return null;

  const shouldShowOffers = !!firm.tags.find(
    item => item.slug === 'zapchasti' || item.slug === 'avtorazborka',
  );

  const tab = params.tab || (shouldShowOffers ? DEALER_TABS.OFFERS : DEALER_TABS.ABOUT);

  if (!Object.values(DEALER_TABS).includes(tab)) {
    return null;
  }

  if (!firm || !firm.id) {
    return null;
  }
  if (!state.searchForm.selected.firm) await store.dispatch(sparesFormFillThunks.firm(firm.id));

  const [news, firmAboutArticleResponse] = await Promise.all([
    tab === DEALER_TABS.BLOG ? fetchNews(fetch, firm.id, locale) : Promise.resolve({}),
    tab === DEALER_TABS.ABOUT
      ? fetch(API.JOURNAL.LIST({ agency: firm.id, rubric: 'home-page' })).then(r =>
          r.ok ? r.json() : {},
        )
      : Promise.resolve({}),
  ]);

  const firmsTypes = uniq(
    types
      .filter(type => FIRMS_TYPE_IDS.includes(type.id))
      .map(type => {
        if (type && LINKS.SEARCH[type.slug]) {
          return type;
        } else if (type.parents && type.parents.length > 0) {
          return types.find(item => item.id === type.parents[0]);
        }

        return type;
      }),
  );

  const { page, transport } = query;
  const currentPage = page ? parseFloat(page) : 1;

  const currentTransportId = transport || AUTO_ID;

  const transportType = types.find(item => +item.id === +currentTransportId);

  const currency = state.searchForm.selected && state.searchForm.selected.currency;

  const q = { ...query };

  delete q.tab;
  q.firm = firm.id;
  q.page = currentPage;
  q.transport = transportType.id || 1;
  q.currency = currency.slug;
  q.isCrashed = q.isNew ? null : q.isCrashed;
  if (q.isNew === undefined) {
    q.isNew = null;
  }
  const queryParams = queryString.stringify(snakeCaseKeys(q));

  const carsListTypes = {
    result: queryString.stringify(snakeCaseKeys(q)),
  };

  Object.keys(q).forEach(key => {
    const item = q[key];
    if (sparesFormFillThunks[key]) {
      store.dispatch(sparesFormFillThunks[key](item));
    }
  });

  await store.dispatch(selectedActions.set.transport(transportType));

  const [makes, rubrics] = await Promise.all([
    fetch(API.VOCABULARY.makes(currentTransportId)).then(r => r.json()),
    fetch(API.VOCABULARY.rubrics(currentTransportId)).then(r => r.json()),
  ]);

  store.dispatch(
    setFormVocabulary({
      makes: [...makes].sort(compareByTitle),
      rubrics,
    }),
  );

  const title = TITLE.FIRM_PAGE(firm.title, tab, translate, firm.car_drive_countries, firm.tags);
  const description = DESCRIPTION.FIRM_PAGE(firm.title, tab, translate, firm.car_drive_countries, firm.tags, firm);

  await store.dispatch(sparesSetThunks.count());
  await store.dispatch(resultsThunks.searchSparesResults(carsListTypes.result));

  const aboutArticle =
    firmAboutArticleResponse.count > 0 ? firmAboutArticleResponse.results[0] : {};

  return {
    queryParams,
    currentPage,
    title,
    description,
    firmInfo: {
      ...firm,
      description: aboutArticle.content || firm.description,
    },
    news: news.results,
    newsPage: parseInt(query.page || 1, 10),
    newsPageCount: Math.ceil(news.count / PER_PAGE),
    query,
    url,
    tab,
    firmsTypes,
    shouldShowOffers,
    transportType,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/shared/routes/firms/firm/index.js